module.exports = __webpack_public_path__ + "static/img/helmetSmall.3908b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/helmetSmall.png
// module id = 805
// module chunks = 2